<template>
  <div id="pwreset">
    <el-container>
      <el-header><i class="fas fa-lock-open"></i> パスワードリセット</el-header>
      <el-main>
        <el-form ref="refFrmReset" :model="frmReset" :rules="rules" label-width="150px">
          <el-form-item label="パスワード" prop="password">
            <el-input placeholder="パスワードを入力してください。" v-model="frmReset.password" show-password></el-input>
          </el-form-item>
          <el-form-item label="パスワード（確認）" prop="checkPass">
            <el-input placeholder="確認のため再入力してください。" v-model="frmReset.checkPass" show-password autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <el-alert :title="message.msg" type="error" v-if="message.err"></el-alert>
            <el-alert :title="message.msg" type="success" v-if="message.msg && !message.err"></el-alert>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm">リセット</el-button>
          </el-form-item>
        </el-form>
      </el-main>
    </el-container>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, ref, getCurrentInstance } from 'vue';
import { useRoute } from 'vue-router';

export default defineComponent({
  setup() {
    const route = useRoute()
    const internalInstance = getCurrentInstance()
    const refFrmReset: any = ref(null)
    const message = reactive({
      msg: '',
      err: false
    })
    const frmReset = reactive({
      password: '',
      checkPass: ''
    })
    const validatePass2 = (rule: any, value: string, callback: any) => {
        if(value === '') {
          callback(new Error('確認用パスワードを入力してください。'));
        }else if(value !== frmReset.password) {
          callback(new Error('2回入力されたパスワードが一致しません。'));
        }else {
          callback();
        }
    }
    const rules = {
      password: [
        { required: true, message: 'パスワードを入力してください。', trigger: 'blur' },
        { min: 8, message: '8文字以上必要です。', trigger: 'blur' }
      ],
      checkPass: [
        { validator: validatePass2, trigger: 'blur' }
      ]
    }
    const submitForm = () => {
      refFrmReset.value.validate((valid: boolean) => {
        if(valid) {
          const api_path = internalInstance?.appContext.config.globalProperties.api_path
          fetch(api_path + 'ajax/pwreset.php', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              'password': frmReset.password,
              'email': route.query.id,
              'token': route.query.token
            })
          })
          .then(response => response.json())
          .then(json => {
            //console.log(json);
            if(json['result'] == 'failure') {
              throw new Error(json.error)
            }
            message.msg = "リセットしました。";
            message.err = false;
          })
          .catch(error => {
            console.error(error)
            message.err = true
            message.msg = error.message
          })
        }
      })
    }

    return {
      message,
      frmReset,
      refFrmReset,
      submitForm,
      rules,
    }
  }
})
</script>

<style>
#pwreset {
  height: calc(100% - 69px);
  background-color: #ecf0f5;
  position: relative;
  overflow: auto;
}
#pwreset .el-header {
  padding-top: 30px;
  color: #6f6f6f;
  font-size: larger;
  text-align: center;
}
#pwreset .el-container {
  width: 450px;
  margin: 0 auto;
}
#pwreset .el-main {
  text-align: left;
}
</style>